import axios from "axios";
import { message } from "ant-design-vue";
import { useUserInfoStore } from "@/store/userInfo";

const service = axios.create({
  // baseURL: "http://127.0.0.1:8000", // url = base url + request url
  timeout: 70000, // request timeout
});

service.interceptors.request.use(
  (config) => {
    const userInfoStore = useUserInfoStore();
    if (userInfoStore.access) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      config.headers.Authorization = `Bearer ${userInfoStore.access}`;
    }
    return config;
  },
  (error) => {
    message.error(error.message).then();
    return Promise.reject(error);
  }
);

service.interceptors.response.use(undefined, (error) => {
  const userInfoStore = useUserInfoStore();
  const status = error.response.status;
  switch (status) {
    case 401: {
      message.warn(error.response.data.detail).then();
      userInfoStore.clearUserInfo();
      break;
    }
    default: {
      const data = error.response.data;
      if (data.username) message.error(data.username).then();
      else message.error(error.response.data).then();
    }
  }
  return Promise.reject(error);
});

export default service;
